var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","column-config":{ minWidth: '80px' },"toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"size":"mini","mouse-config":{ area: true },"highlight-hover-row":"","highlight-current-row":"","height":_vm.tableHeight,"columns":_vm.gridColumns,"edit-rules":_vm.validRules,"edit-config":{
      trigger: 'dblclick',
      mode: 'cell',
      activeMethod: _vm.activeMethod
    },"keyboard-config":{
      isArrow: true,
      isEnter: true,
      isTab: true,
      isClip: true,
      enterToTab: true,
      isEdit: true,
      editMethod: _vm.editMethod
    },"cell-class-name":_vm.cellClassName,"menu-config":{ body: { options: _vm.bodyMenus }, visibleMethod: _vm.visibleMethod }},on:{"toolbar-button-click":_vm.toolbarButtonClickEvent,"menu-click":_vm.contextMenuClickEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }